export const CATEGORY_MAP = {
  estate: { label: 'Estate Sale', tagClass: 'tag-estate', color: '#FFD166' },
  garage: { label: 'Garage Sale', tagClass: 'tag-garage', color: '#4CB944' },
  auction: { label: 'Auction', tagClass: 'tag-auction', color: '#FF6B35' },
  moving: { label: 'Moving Sale', tagClass: 'tag-moving', color: '#6C63FF' },
  business_closing: { label: 'Business Going Out', tagClass: 'tag-business', color: '#E84855' },
  craft_fair: { label: 'Craft Fair', tagClass: 'tag-vendor', color: '#00B4D8' },
  food_vendor: { label: 'Food Vendor', tagClass: 'tag-vendor', color: '#F77F00' },
  carnival: { label: 'Carnival', tagClass: 'tag-vendor', color: '#D62828' },
  vendor_event: { label: 'Vendor Event', tagClass: 'tag-vendor', color: '#7209B7' },
};

export function getCategoryLabel(cat) {
  return CATEGORY_MAP[cat]?.label || cat;
}

export function getCategoryColor(cat) {
  return CATEGORY_MAP[cat]?.color || '#FFD166';
}
